import { downloadResource } from '@/services/api'

function normalizedPngFilename(filename) {
  const safeName = String(filename || 'image')
    .replace(/[<>:"/\\|?*\u0000-\u001f]/g, '-')
    .replace(/\.(?:png|jpe?g|webp)$/i, '')
    .replace(/\.+$/g, '')
    .trim()
  return `${safeName || 'image'}.png`
}

function imageElementFromBlob(blob) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(blob)
    const image = new Image()
    image.onload = () => {
      URL.revokeObjectURL(objectUrl)
      resolve(image)
    }
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl)
      reject(new Error('无法读取待下载图片'))
    }
    image.src = objectUrl
  })
}

async function convertBlobToPng(blob) {
  if (String(blob.type || '').toLowerCase() === 'image/png') return blob

  let drawable
  let width
  let height
  if (typeof window.createImageBitmap === 'function') {
    drawable = await window.createImageBitmap(blob)
    width = drawable.width
    height = drawable.height
  } else {
    drawable = await imageElementFromBlob(blob)
    width = drawable.naturalWidth
    height = drawable.naturalHeight
  }

  if (!width || !height) throw new Error('图片尺寸无效，无法转换为 PNG')
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const context = canvas.getContext('2d')
  if (!context) throw new Error('当前浏览器无法转换 PNG 图片')
  context.drawImage(drawable, 0, 0, width, height)
  if (drawable && typeof drawable.close === 'function') drawable.close()

  const pngBlob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'))
  canvas.width = 1
  canvas.height = 1
  if (!pngBlob) throw new Error('PNG 图片转换失败')
  return pngBlob
}

function triggerBlobDownload(blob, filename) {
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
}

export function downloadGeneratedImageDirectly(taskId, filename) {
  const normalizedTaskId = String(taskId || '').trim()
  if (!normalizedTaskId) throw new Error('没有可下载的图片')
  const downloadFilename = normalizedPngFilename(filename)
  const link = document.createElement('a')
  link.href = `/api/generated-images/${encodeURIComponent(normalizedTaskId)}/download?filename=${encodeURIComponent(downloadFilename)}`
  link.download = downloadFilename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export async function getImageAsPngBlob(url, options = {}) {
  if (!url) throw new Error('没有可下载的图片')
  const sourceBlob = await downloadResource(url, options)
  return convertBlobToPng(sourceBlob)
}

export async function downloadImageAsPng(url, filename, options = {}) {
  const pngBlob = await getImageAsPngBlob(url, options)
  triggerBlobDownload(pngBlob, normalizedPngFilename(filename))
}

export async function getOriginalImageBlob(url, options = {}) {
  if (!url) throw new Error('没有可下载的图片')
  return downloadResource(url, options)
}

export function originalImageFilename(blob, filename) {
  if (!blob || !blob.size) throw new Error('图片内容为空')
  const extension = {
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'image/webp': '.webp',
    'image/gif': '.gif'
  }[String(blob.type || '').toLowerCase()] || '.jpg'
  const safeName = String(filename || 'image')
    .replace(/[<>:"/\\|?*\u0000-\u001f]/g, '-')
    .replace(/\.(?:png|jpe?g|webp|gif)$/i, '')
    .replace(/\.+$/g, '')
    .trim()
  return `${safeName || 'image'}${extension}`
}

export function downloadOriginalImageBlob(blob, filename) {
  triggerBlobDownload(blob, originalImageFilename(blob, filename))
}
/**
 * 结果图片下载工具：处理远程图片跨域和浏览器下载限制。
 */
